<template>
  <div id="roadSideOutParkHisSum">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>路侧数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>离场历史数据统计</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm"
                            type="datetime"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-checkbox v-model="pageSearch.isArr">只显示补缴记录</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fInParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备账号::">
            <el-select v-model="pageSearch.fDevAccID"
                       clearable
                       filterable
                       placeholder="请选择设备"
                       style="width:200px;">
              <el-option v-for="item in devacc_list"
                         :key="item.fDevAccID"
                         :label="item.fDevAccNo+':'+item.fLinkman"
                         :value="item.fDevAccID">
                <!-- <span style="float: left">{{ item.fDevAccNo }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fLinkman }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付状态::">
            <el-select v-model="pageSearch.payStatus"
                       clearable
                       filterable
                       placeholder="请选择支付状态"
                       style="width:200px;">
              <el-option v-for="item in payStatusList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <!--<el-button type="success"-->
                       <!--size="small"-->
                       <!--icon="el-icon-share"-->
                       <!--:loading="export_loading"-->
                       <!--v-if="is_export"-->
                       <!--@click="exportData">{{export_msg}}</el-button>-->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCount"
                           align="right"
                           label="离场总数">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           align="right"
                           label="计费总额">
          </el-table-column>
          <el-table-column prop="fDedAmt"
                           align="right"
                           label="抵扣总额">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           align="right"
                           label="支付总额">
          </el-table-column>
          <el-table-column prop="cashfPayAmt"
                           align="right"
                           label="现金支付总额">
          </el-table-column>
          <el-table-column prop="onlinefPayAmt"
                           align="right"
                           label="电子支付总额">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { report as api } from '../../../api/roadSideReport'
import * as park from '../../../api/park'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      loading: false,
      payStatusList: [
        { value: 1, label: '现金支付' },
        { value: 2, label: '电子支付' },
        { value: 10, label: '免费支付' },
        { value: 11, label: '手动免费支付' },
        { value: 20, label: '支付异常' }
        // { value: 12, label: '欠费离场' },
      ],
      pageData: [],
      cust_list: [],
      park_list: [],
      devacc_list: [],
      startTime: '',
      endTime: '',
      pageSearch: {
        payStatus: '',
        fDevAccID: '',
        fCustID: '',
        fInParkID: '',
        isArr: false,
        // type: 0,
        fstartTime: '',
        fendTime: '',
        searchKeyWord: ''
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      this.pageData = []
      this.loading = true
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      api.outParkHisDataSum(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData.push(data.Data)
          } else {
            this.$message.error('提示：离场数据加载失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      // 加载离场数据列表
      // this.page_list()
      this.pageSearch.fInParkID = ''
      this.park_list = []
      this.pageSearch.fDevAccID = ''
      this.devacc_list = []
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
      api.pdaList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.devacc_list = data.Data || []
          } else {
            this.$message.error('提示：加载设备账号列表失败')
          }
        }
      })
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 246
      obj.tableHeight = clientHeight
    }
  },
  created () {
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
  /* dialog弹出框样式 */
  #roadSideOutParkHisSum .el-dialog {
    min-width: 840px;
  }
  #roadSideOutParkHisSum .el-dialog__headerbtn {
    top: 10px;
    font-size: 20px;
  }
  #roadSideOutParkHisSum .el-dialog__title {
    color: white;
  }
  #roadSideOutParkHisSum .el-dialog__header {
    background-color: #337ab7;
    padding: 10px;
  }
  #roadSideOutParkHisSum .el-dialog__body {
    padding: 3px 10px;
    font-size: 13px;
    /* font-family: "宋体"; */
  }
  /* 文本框样式 */
  #roadSideOutParkHisSum .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  #roadSideOutParkHisSum .el-input.is-disabled .el-input__inner,
  #roadSideOutParkHisSum .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
  #roadSideOutParkHisSum .el-tabs__item {
    height: 32px;
    line-height: 32px;
  }
  #roadSideOutParkHisSum .el-input__icon {
    line-height: 32px;
  }
  /* end */
</style>
<style scoped>
  .el-form-item {
    margin-bottom: 5px;
  }
  .pagination {
    text-align: right;
    padding-top: 5px;
  }
  .search {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/report/roadSideOutParkHisSum.vue